// src/tabs/ClaimsTab.jsx
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Avatar,
  Chip,
  Button,
  IconButton,
} from "@mui/material";

import BuildIcon from "@mui/icons-material/Build";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";

import { formatDateTime } from "../../../utils/helpers";
import { useOutletContext } from "react-router-dom";

export default function ClaimsTab() {
  const {
    claims = [],
    claimsLoading,
    onRaiseClaim,
    onOpenClaimDetails,
  } = useOutletContext();

  const getStatusColor = (status) => {
    switch (status) {
      case "otp_sent":
        return "warning";
      case "completed":
        return "success";
      case "rejected":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <Stack spacing={2}>
      {/* HEADER */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontWeight={900}>My Claims</Typography>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ borderRadius: 2 }}
          onClick={() => onRaiseClaim?.()}
        >
          Raise Claim
        </Button>
      </Stack>

      {/* LOADING */}
      {claimsLoading && (
        <Typography variant="body2" color="text.secondary">
          Loading claims...
        </Typography>
      )}

      {/* EMPTY STATE */}
      {!claimsLoading && claims.length === 0 && (
        <Card sx={{ borderRadius: 4 }}>
          <CardContent>
            <Typography fontWeight={900}>
              No claims yet
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              Tap “Raise Claim” to start.
            </Typography>
          </CardContent>
        </Card>
      )}

      {/* CLAIM LIST */}
      <Stack spacing={1.5}>
        {claims.map((cr) => (
          <Card
            key={cr.id}
            sx={{
              borderRadius: 4,
              cursor: "pointer",
              transition: "transform 120ms ease",
              "&:hover": { transform: "translateY(-1px)" },
            }}
          >
            <CardContent>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar sx={{ bgcolor: "#eef2ff" }}>
                  <BuildIcon color="primary" />
                </Avatar>

                {/* DETAILS */}
                <Stack flex={1}>
                 
                   <Typography fontWeight={900}>
                     {cr.device?.brand} {cr.device?.model}
                  </Typography>
                  <Typography fontWeight={600}>
                    {cr.device?.product_name} 
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    Claim ID: <b>{cr.id}</b>
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    IMEI: {cr.device?.imei1 || "—"}
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    Created: {formatDateTime(cr.created_at)} •{" "}
                    {cr.claim_type === "pickup"
                      ? "Pickup"
                      : "Drop-off"}
                  </Typography>
                </Stack>

                {/* STATUS */}
                <Stack alignItems="flex-end" spacing={0.5}>
                  <Chip
                    size="small"
                    label={cr.status.replace("_", " ").toUpperCase()}
                    color={getStatusColor(cr.status)}
                  />
                  <IconButton onClick={() => onOpenClaimDetails?.(cr)}>
                    <ChevronRightIcon />
                  </IconButton>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}



// // src/tabs/ClaimsTab.jsx
// import React from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Stack,
//   Avatar,
//   Chip,
//   Button,
//   IconButton,
// } from "@mui/material";

// import BuildIcon from "@mui/icons-material/Build";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import AddIcon from "@mui/icons-material/Add";
// import { formatDateTime } from "../../../utils/helpers";
// import { useOutletContext } from "react-router-dom";


// /**
//  * ClaimsTab
//  * - Claim listing
//  * - Status timeline preview
//  * - Payment status visibility
//  */
// export default function ClaimsTab() {
//   const {
//     devices = [],
//     claimRecords = [],
//     onRaiseClaim,
//   } = useOutletContext();

//   const getDeviceName = (id) =>
//     devices.find((d) => d.id === id)?.name || "Device";

//   return (
//     <Stack spacing={2}>
//       {/* HEADER */}
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//       >
//         <Typography fontWeight={900}>My Claims</Typography>

//         <Button
//           variant="contained"
//           startIcon={<AddIcon />}
//           sx={{ borderRadius: 2 }}
//           onClick={() => onRaiseClaim?.()}
//         >
//           Raise Claim
//         </Button>
//       </Stack>

//       {/* EMPTY STATE */}
//       {claimRecords.length === 0 && (
//         <Card sx={{ borderRadius: 4 }}>
//           <CardContent>
//             <Typography fontWeight={900}>
//               No claims yet
//             </Typography>
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{ mt: 0.5 }}
//             >
//               Tap “Raise Claim” to start.
//             </Typography>
//           </CardContent>
//         </Card>
//       )}

//       {/* CLAIM LIST */}
//       <Stack spacing={1.5}>
//         {claimRecords.map((cr) => {
//           const deviceName = getDeviceName(cr.device_id);
//           const currentStatus =
//             cr.status_history[cr.status_history.length - 1];

//           return (
//             <Card
//               key={cr.id}
//               sx={{
//                 borderRadius: 4,
//                 cursor: "pointer",
//                 transition: "transform 120ms ease",
//                 "&:hover": { transform: "translateY(-1px)" },
//               }}
//             >
//               <CardContent>
//                 <Stack
//                   direction="row"
//                   spacing={1.5}
//                   alignItems="center"
//                 >
//                   <Avatar sx={{ bgcolor: "#eef2ff" }}>
//                     <BuildIcon color="primary" />
//                   </Avatar>

//                   <Stack flex={1}>
//                     <Typography fontWeight={900}>
//                       {deviceName}
//                     </Typography>

//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                     >
//                       Claim ID: <b>{cr.id}</b>
//                     </Typography>

//                     <Typography
//                       variant="caption"
//                       color="text.secondary"
//                     >
//                       Created:{" "}
//                       {formatDateTime(cr.created_at)} •
//                       Service:{" "}
//                       {cr.service === "pickup"
//                         ? "Pickup"
//                         : "Drop-off"}
//                     </Typography>
//                   </Stack>

//                   <Stack
//                     alignItems="flex-end"
//                     spacing={0.5}
//                   >
//                     <Chip
//                       size="small"
//                       label={currentStatus.label}
//                       color={currentStatus.color}
//                     />
//                     <IconButton>
//                       <ChevronRightIcon />
//                     </IconButton>
//                   </Stack>
//                 </Stack>
//               </CardContent>
//             </Card>
//           );
//         })}
//       </Stack>
//     </Stack>
//   );
// }
